module.exports = __webpack_public_path__ + "img/5.349aa009.png";